import { InputRule } from 'prosemirror-inputrules';
import { LinkSpecs, linkMarkName, linkType } from './LinkSpecs';
import { linkCommand } from './actions';
import { linkPasteEnhance } from './paste-plugin';
export { linkCommand } from './actions';
export { normalizeUrlFactory } from './utils';
export { removeLink } from './commands';
export { LinkAttr, linkMarkName, linkType } from './LinkSpecs';
/** @deprecated Use `linkMarkName` instead */
export const link = linkMarkName;
const linkAction = 'link';
export const Link = (builder) => {
    builder.use(LinkSpecs);
    builder
        .addPlugin(linkPasteEnhance, builder.Priority.High)
        .addAction(linkAction, (deps) => linkCommand(linkType(deps.schema), deps))
        .addInputRules(({ schema }) => ({ rules: [linkInputRule(linkType(schema))] }));
};
// TODO: think about generalizing with markInputRule
function linkInputRule(markType) {
    return new InputRule(/\[(.+)]\((\S+)\)\s$/, (state, match, start, end) => {
        // handle the rule only if is start of line or there is a space before "open" symbols
        if (match.index > 0) {
            const re = match;
            if (re.input[re.index - 1] !== ' ')
                return null;
        }
        const [okay, alt, href] = match;
        const { tr } = state;
        if (okay) {
            tr.replaceWith(start, end, markType.schema.text(alt)).addMark(start, start + alt.length, markType.create({ href }));
        }
        return tr;
    });
}
